(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["el-specs"] && !Shopify.designMode) return;
  try {
    (function(){
  function boot(){
    document.querySelectorAll('[data-el-specs]').forEach(function(box){
      if(box.__wired)return; box.__wired=true;
      var mapEl=box.querySelector('[data-med-map]'); if(!mapEl)return;
      var map={}; try{map=JSON.parse(mapEl.textContent);}catch(e){return;}
      var medProd=box.getAttribute('data-med-prod')||'';
      function paint(id){
        var val=(id&&map[id]!=null&&String(map[id]).trim())?map[id]:medProd;
        var row=box.querySelector('[data-med-row]'),vEl=box.querySelector('[data-med-value]');
        if(!row||!vEl)return;
        if(val&&String(val).trim()){vEl.textContent=val;row.style.display='';}else{row.style.display='none';}
      }
      // localizar el form del producto y su input name="id"
      var form=box.closest('.product-information')||document;
      function currentId(){
        var el=form.querySelector('input[name="id"], select[name="id"], [name="id"]');
        return el? el.value : null;
      }
      // pintar al cargar
      paint(currentId());
      // observar cambios del input id (funciona con cualquier tema)
      var idEl=form.querySelector('[name="id"]');
      if(idEl){
        var mo=new MutationObserver(function(){paint(currentId());});
        mo.observe(idEl,{attributes:true,attributeFilter:['value']});
        idEl.addEventListener('change',function(){paint(currentId());});
      }
      // fallback: cualquier change dentro del form de producto
      (form.addEventListener?form:document).addEventListener('change',function(){setTimeout(function(){paint(currentId());},30);});
      // fallback: click en swatches/botones de variante
      document.addEventListener('click',function(e){
        if(e.target.closest&&e.target.closest('variant-picker, .variant-picker, fieldset')){setTimeout(function(){paint(currentId());},60);}
      });
    });
  }
  if(document.readyState!=='loading')boot(); else document.addEventListener('DOMContentLoaded',boot);
})();
  } catch(e) { console.error(e); }
})();

})();
